import TabButtonOutlined from './component.jsx'
export default TabButtonOutlined
